<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {

}
</script>


<style lang="scss">
  @import "./assets/scss/app";
  html, body {
    min-height: 100%;
    overflow-y: scroll;
    width: 100%;
  }
  #app {
    min-height: 100vh;
    display: flex;
  }
</style>
